// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd86b0c0","305":"8f689ddf","436":"854f37a3","455":"9f31a35e","499":"be3e5c5a","825":"0caa6e3c"}[chunkId] + ".chunk.js";
};